"use client";

import { Hero } from "./hero";
// perf(forge 2026-09-11): Engines is the homepage's only recharts consumer
// (4 radar charts) — same pattern as the sibling governli/cerebras fixes: keep
// its ~280KB chart chunk out of the initial script set via dynamic ssr:false
// behind a reserved-height IntersectionObserver boundary.
import dynamic from "next/dynamic";
import { LazyOnVisible } from "./lazy-boundary";
const EnginesLazy = dynamic(() => import("./engines").then((m) => m.Engines), {
  ssr: false,
  loading: () => null,
});
import { TrustStrip } from "./trust-strip";
import { SiteDirectory } from "./directory";
import { ExecutiveSummary } from "./exec-summary";
import { Challenge } from "./challenge";
import { Solution } from "./solution";
import { PlatformOverview } from "./platform-overview";
import { KeyMetrics } from "./key-metrics";
import { Capabilities } from "./capabilities";
import { HowItWorks } from "./how-it-works";
import { DeploymentTiers } from "./deployment-tiers";
import { Process } from "./process";
import { Deliverables } from "./deliverables";
import { Outcomes } from "./outcomes";
import { Benefits } from "./benefits";
import { Usps } from "./usps";
import { WhoItsFor } from "./who-its-for";
import { Industries } from "./industries";
import { WhyChooseUs } from "./why-choose-us";
import { FAQ } from "./faq";
import { PAA } from "./paa";
import { RelatedServices } from "./related-services";
import { About } from "./about";
import { CtaContact } from "./cta-contact";

export function HomePage() {
  return (
    <>
      <Hero />
      <TrustStrip />
      <div className="bg-aurora-violet">
        <SiteDirectory />
      </div>
      <div className="bg-aurora-crimson">
        <ExecutiveSummary />
      </div>
      <Challenge />
      <div className="bg-aurora-purple">
        <Solution />
      </div>
      <PlatformOverview />
      <div className="bg-aurora-cyan bg-grid-overlay">
        <KeyMetrics />
      </div>
      <Capabilities />
      <div className="bg-aurora-emerald">
        <HowItWorks />
      </div>
      <LazyOnVisible minHeight={900}><EnginesLazy /></LazyOnVisible>
      <div className="bg-aurora-amber">
        <DeploymentTiers />
      </div>
      <Process />
      <div className="bg-aurora-crimson">
        <Deliverables />
      </div>
      <Outcomes />
      <Benefits />
      <Usps />
      <WhoItsFor />
      <div className="bg-aurora-purple">
        <Industries />
      </div>
      <WhyChooseUs />
      <div className="bg-aurora-cyan">
        <FAQ />
      </div>
      <PAA />
      <RelatedServices />
      <About />
      <CtaContact />
    </>
  );
}
